<template>
  <div class="news-content-container">
    <back-open-chenter />
    <div class="news-content-panel">
      <div class="news-title">论坛预告 | 9月3日，腾讯WAIC论坛与你瞰见未来</div>
      <div class="news-date">2022年8月20日</div>
      <div class="news-content">
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news17/news17_17.gif"/>
          </div>
        </div>
        <p>
          一年一度的
          <span class="mark-text">世界人工智能大会（WAIC）</span>
          如期而至，每年我们都在这场AI的盛会中讨论技术对社会、对生活的深刻影响。去年WAIC腾讯论坛以“你即为光”为主题，致敬每一次为科技进步所提供的创新和改变。
        </p>
        <p>
          这些科技之光照亮的不仅仅是当下，而是去往更为深远的地方，在许多我们不曾关注的领域引发趋势与变革。因而今年腾讯论坛希望与各界一同开启
          <span class="mark-text high-light">“瞰见”</span>
          模式，从更高的角度思考下一阶段AI与世界协同发展之道，共同探讨人类文明在技术的影响下将走向何方，又将迎来何种突破。
        </p>
        <p>今年我们很荣幸的邀请到来自不同领域的专家和学者，与我们一同探讨思考科技与社会的可持续发展。</p>
        <p>下面，为大家揭晓此次论坛的嘉宾阵容（嘉宾信息按议程排序）：</p>
        <div class="news-content-mark">
          <h2>李强</h2>
        </div>
        <div>
          <div class="image-panel">
            <img class="poster" src="../img/detail/news19_1.jpeg"/>
          </div>
        </div>
        <p>现任腾讯公司副总裁、政企业务总裁，全面负责政务、工业、能源、 农业、文旅、体育、地产、运营商等行业及区域团队管理与业务拓展，致力于运用最新的数字技术，充分结合政府、企业的数字化需求，提升政务公共服务及社会治理效率，加速企业的业务成长创新和转型升级。</p>
        <p>2021年5月加入腾讯，进入腾讯前曾任SAP全球高级副总裁、中国区总经理。李强先生有着20余年IT从业经验，对商业软件、云计算以及创新的商业模式有着非常前瞻和深入的理解。</p>
        <p>2018年，李强先生当选为第十三届上海市政协委员，并被评为“中国ICT产业十大影响力人物”。2019年，李强先生受聘担任陕西省人民政府国际高级经济顾问，对外经济贸易大学客座教授，并当选《经济观察报》评选的“2019年度中国受尊敬企业家奖”。2020年，李强先生受聘担任重庆市市长国际经济顾问。</p>

        <div class="news-content-mark">
          <h2>张立军</h2>
        </div>
        <div>
          <div class="image-panel">
            <img class="poster" src="../img/detail/news19_2.jpeg"/>
          </div>
        </div>
        <p>自2003年加入腾讯后，先后领导了包括QQ会员、QQ邮箱、QQ秀、QQ空间等在内的多款腾讯核心产品的研发工作，并协助创立了腾讯集团研发管理部，打造了腾讯的研发质量管理体系和研发人员职业等级评定和培养体系。他在新一代互联网技术服务数字经济、产业升级、文化创新等领域具有丰富的经验。</p>
        <div class="news-content-mark">
          <h2>吴运声</h2>
        </div>
        <div>
          <div class="image-panel">
            <img class="poster" src="../img/detail/news19_3.jpeg"/>
          </div>
        </div>
        <p>毕业于北京大学，拥有计算机硕士学位，现任腾讯云副总裁，腾讯优图实验室总经理、上海市人工智能联盟副理事长。</p>
        <p>于2007年加入腾讯，先后负责QQ影音、QQ旋风、QQ浏览器、天天P图等产品，具有丰富的研发技术和产品能力。2012年，吴运声一手组建腾讯优图实验室，聚焦计算机视觉，专注在图像处理、图像识别等领域开展技术研发和业务落地。2020年，吴运声全面负责腾讯云AI的产品研发与项目管理工作，在Gartner发布的2022研究报告中，腾讯云AI在“执行能力”(产品、服务、销售等)维度的位蝉联国内厂商第一，其中，腾讯AI在计算机视觉领域首次进入全球前二。</p>
        <div class="news-content-mark">
          <h2>荆彦青</h2>
        </div>
        <div>
          <div class="image-panel">
            <img class="poster" src="../img/detail/news19_4.jpeg"/>
          </div>
        </div>
        <p>现任腾讯互动娱乐品质管理部总经理，腾讯先锋云游戏总经理，腾讯质量通道委员会会长，国家广播电视总局高新视频互动场景创新实验室主任。荆彦青于2004年加入腾讯，先后负责腾讯游戏质量保障、腾讯WeTest、先锋云游戏、Perfdog等众多业务和产品，具有丰富的研发技术和产品能力。</p>
        <p>作为腾讯资深测试专家，2004～2013年期间，带领团队曾主导了腾讯多款明星游戏的质量保障项目，包括qq堂、qq幻想、王者荣耀、DNF、英雄联盟等众多知名游戏；同期主导了腾讯“无人机”、“智能玩具车” 等智能硬件研发，积极布局未来科技预研。2014年，荆彦青一手组建品质管理部，部门每年产出多款软硬件产品和数百项发明专利，引领了腾讯游戏品质管理的技术研发的方向。2015年，荆彦青带领团队构建WeTest平台，开放技术，赋能行业，至今为止腾讯WeTest已经服务了上万家企业，成为行业具影响力的质量云平台之一。2017年，荆彦青带领团队孵化了腾讯首个云游戏业务-腾讯先锋云游戏，目前腾讯先锋在云游戏的技术研发和产品创新及商业化应用上取得了众多划时代的重大业务突破。</p>
        <div class="news-content-mark">
          <h2>万超</h2>
        </div>
        <div>
          <div class="image-panel">
            <img class="poster" src="../img/detail/news19_5.jpeg"/>
          </div>
        </div>
        <p>现任腾讯数字孪生产品副总裁。国家住房与城乡建设部协同创新专家委员、国家一级注册结构师、高级工程师。</p>
        <p>在建筑领域有超过三十年的丰富的管理经验，曾担任多个大型公司的主要领导人，主导多个城市标杆项目建设。2010年加入腾讯，曾任腾讯智慧空间副总裁、腾讯云副总裁，基于腾讯云、图、AI、物联网、等关键技术，构建空间的多源数据融汇，是腾讯集团在智慧空间领域的推动者和实践人。自2022年起，担任腾讯数字孪生产品副总裁，全面负责腾讯数字孪生产品，面向交通、能源、工业、建筑等众多行业，打造前沿创新技术应用和数字化解决方案。</p>
        <div class="news-content-mark">
          <h2>杜晓宇</h2>
        </div>
        <div>
          <div class="image-panel">
            <img class="poster" src="../img/detail/news19_6.jpeg"/>
          </div>
        </div>
        <p>腾讯研究院副院长，高级经济师，金融科技50人论坛青年成员、首席召集人。主要从事金融科技、金融政策研究。</p>
        <div class="news-content-mark">
          <h2>李肇宁</h2>
        </div>
        <div>
          <div class="image-panel">
            <img class="poster" src="../img/detail/news19_7.jpeg"/>
          </div>
        </div>
        <p>现任交通银行金融科技部总经理，兼金融科技创新研究院院长，领导交通银行金融科技部，负责全集团信息技术全流程工作的统筹规划、顶层设计与扎口管理。他还领导交通银行金融科技研究院，负责人工智能等基础性、前沿性技术及产品研发。</p>

        <div class="news-content-mark">
          <h2>郭仁声</h2>
        </div>
        <div>
          <div class="image-panel">
            <img class="poster" src="../img/detail/news19_8.jpeg"/>
          </div>
        </div>
        <p>腾讯云副总裁、金融行业负责人。自加入腾讯后，带领团队不断完善产品和服务矩阵，帮助银行、保险、券商等各类金融机构加速数字化转型的进程，赢得众多客户的认可和良好口碑，助力中国产业互联网的发展。</p>

        <div class="news-content-mark">
          <h2>李菂</h2>
        </div>
        <div>
          <div class="image-panel">
            <img class="poster" src="../img/detail/news19_9.jpeg"/>
          </div>
        </div>
        <p>国家天文台“中国天眼"FAST首席科学家。发现星际氧气分子，领导发现FAST首批新脉冲星，首批新快速射电暴。成果入选”中国科学十大进展”。参与领导多项国际合作，例如任突破聆听计划（Breakthrough Listen）指导委员，平方公里阵SKA“生命摇篮”工作组组长等。</p>

        <div class="news-content-mark">
          <h2>吴敏霞</h2>
        </div>
        <div>
          <div class="image-panel">
            <img class="poster" src="../img/detail/news19_10.jpeg"/>
          </div>
        </div>
        <p>中国女子跳水运动员，中国历史上首位女性奥运“五金”冠军，奥运全球个人成绩榜排名第一位的中国运动员，被媒体评价为“传奇运动员”。党的“十九大”上海市党代表，现任共青团上海市委兼职副书记、上海体育局团委副书记。</p>

        <div class="news-content-mark">
          <h2>陈妍</h2>
        </div>
        <div>
          <div class="image-panel">
            <img class="poster" src="../img/detail/news19_11.jpeg"/>
          </div>
        </div>
        <p>2003年加入腾讯，腾讯公司第一位专职交互设计师及用户研究工程师，主导设计过多款中国互联网成功产品及活动；并通过海量用户的产品研究项目（如微信等）以及中国互联网网民基础研究项目，积累多年研究经验，打造具有互联网特色的研究工具和平台，见证互联网产品从零到数亿用户的发展历程。</p>
        <p>在技术探索上，建立了“互联网银行用户体验实验室”、“互联网保险用户体验联合实验室”“社交广告品牌与用户体验研究实验室”以及“互联网公益”“数字广东产品规划设计部”等方向的团队，培养人才及积累面向C端，B端及G端的服务设计经验。</p>
        <p>主编和主导撰写了首本中国互联网用户体验设计重磅图书《在你身边，为你设计：腾讯用户体验设计之道》。</p>

        <div class="news-content-mark">
          <h2>杨鹏</h2>
        </div>
        <div>
          <div class="image-panel">
            <img class="poster" src="../img/detail/news19_12.jpeg"/>
          </div>
        </div>
        <p>2008年加入腾讯，先后从事政府事务与信息安全工作，现任腾讯安全管理部副总经理、腾讯知识产权部副总经理、腾讯信息安全执委会主任、腾讯安全研究中心主任，对安全策略制定、安全体系建设、安全危机事件应对及生态安全研究具有丰富经验，并主导腾讯安全研究中心相关研究课题，分管腾讯标准团队。</p>
        <p>2016年组建腾讯标准化团队，组织专门队伍开展互联网领域标准制定与应用工作，团队主导制定100多项国际、国家、行业、团体标准，涉及云计算、大数据、人工智能、区块链、网络安全、社会治理、游戏等领域。主导发布《腾讯标准化白皮书》（2019、2020、2021）。</p>

        <div class="news-content-mark">
          <h2>汪铖杰</h2>
        </div>
        <div>
          <div class="image-panel">
            <img class="poster" src="../img/detail/news19_13.jpeg"/>
          </div>
        </div>
        <p>腾讯优图实验室研究总监。在计算机视觉、模式识别与机器学习领域有近15年的研究经历。作为腾讯优图实验室成立时的核心成员之一，研究成果广泛应用于腾讯云、微信、腾讯会议、QQ等；发表包括CVPR、ICCV、ECCV、NeurIPS、AAAI、IJCAI在内的学术论文近70篇，已获得授权的国内国际专利超过110项。</p>
        <div class="conference-info">
          <div class="header">
            <div class="title">2022世界人工智能大会·腾讯论坛</div>
            <div class="subtitle">「瞰见未来」</div>
          </div>
          <div class="body">
            <div class="time">2022年9月3日，上午</div>
            <div class="place">上海世博中心</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
export default {
  name: 'News19',
  components: {
    BackOpenChenter
  }
};
</script>

<style lang="less" scoped>
@import "./news.less";
.news-content {
  margin: 0 auto;
  .high-light {
    color: rgb(1, 82, 217);
  }
  .news-content-mark {
    margin-top: 40px;
  }
  .image-panel {
    max-width: 667px;
    text-align: center;
    margin: 40px auto 32px !important;
    span {
      font-size: 12px;
      display: block;
      color: #b9b2b9;
    }
    img {
      max-width: 667px;
    }
    .poster {
      max-width: 561px;
    }
  }
  .conference-info {
  margin: 52px auto 20px;
  width: 667px;
  height: 168px;
  border: 1px solid rgb(115, 166, 132);
  box-shadow: rgb(226, 226, 226) 0px 16px 1px -10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: bold;
  .header {
    width: 100%;
    background: rgb(44, 94, 197);
    color: #ffffff;
    text-align: center;
    font-size: 18px;
    line-height: 28px;
    .subtitle {
      font-size: 16px;
      line-height: 28px;
    }
  }
  .body {
    padding: 20px 0;
    font-size: 15px;
    line-height: 30px;
    .time, .place {
      display: flex;
      align-items: center;
      justify-content: center;
      &::before {
        content: '';
        display: inline-block;
        width: 30px;
        height: 30px;
        margin-right: 14px;
        background-color: rgb(44, 94, 197);
        background-image: url('../img/detail/news19_14.png');
        background-position: center;
        background-size: 100%;
        // vertical-align: -24%;
      }
    }
    .place {
      margin-top: 10px;
      &::before{
        background-image: url('../img/detail/news19_15.png');
      }
    }
  }
}
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News19.vue